import React from 'react';
import { useGetNode } from "services/Nodes";
// @ts-ignore
import styled from 'styled-components/macro';
import { Table, Card, CardHeader, CardBody, CardTitle, CardText, Button } from 'reactstrap';
import DeleteNode from "./DeleteNode";
import DeleteEdge from "./DeleteEdge";

const SelectedNodeContainer = styled.div`
  margin-top: 1rem;

  p {
    margin-bottom: 0;
  }
`;

const SelectLabel = styled.label`
  margin-bottom: 0;

  &:hover {
    cursor: pointer;  
  }
`;

function SelectedNode({ selectedNode = '', selectedEdge = '', setSelectedEdge }: any) {
  const { loading, data } = useGetNode(selectedNode);

  if (!selectedNode) {
    return null;
  }

  if (loading) {
    return <>loading...</>;
  }

  const edges = data?.node?.edges;

  return (
    <SelectedNodeContainer>
      <Card>
        <CardHeader>{selectedNode}</CardHeader>
        <CardBody>
          <CardTitle>Node Info</CardTitle>
          <CardText><label>Lat Long:</label> {data?.node?.coordinates?.lat}, {data?.node?.coordinates?.lng}</CardText>
          <DeleteNode node={selectedNode} />
          <hr />
          <CardTitle>Edges</CardTitle>
          {edges ? (
            <Table>
              <thead>
                <th>ID</th>
                <th>Start Node</th>
                <th>End Node</th>
                <th>Distance</th>
                <th>Actions</th>
              </thead>
              <tbody>
              {edges.map((e:any) => (
                <tr>
                  <td style={e.id === selectedEdge ? { color: 'green' } : {}}>{e.id}</td>
                  <td>{e.nodeOne}</td>
                  <td>{e.nodeTwo}</td>
                  <td>{e.distance}m</td>
                  <td>
                    <SelectLabel onClick={() => setSelectedEdge(e.id)}>Select</SelectLabel> |{' '}
                    <DeleteEdge edge={e.id} />
                  </td>
                </tr>
              ))}
              </tbody>
            </Table>
          ) : (
            <>No Edges Found</>
          )}
        </CardBody>
      </Card>
    </SelectedNodeContainer>
  );
};

export default SelectedNode;
